export enum VerificationMode {
  Full,
  Tilt,
}
